import { render, staticRenderFns } from "./CouponsList.vue?vue&type=template&id=2e41e93e&scoped=true&"
import script from "./CouponsList.vue?vue&type=script&lang=js&"
export * from "./CouponsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e41e93e",
  null
  
)

export default component.exports